<template>
	<section class="view-play-controls">
		<nav>
			<!-- <ChalkyTrainerViewButtonToggleTrajectories v-if="isLoggedIn" /> -->

			<ChalkyTrainerViewButtonFullscreen class="no-ios no-app" />

			<!-- <ChalkyTrainerViewButtonToggleMove v-bind:class="{ active: isMoveMode }" /> -->

			<ChalkyTrainerViewButtonRackEight />

			<ChalkyTrainerViewButtonRackNine />

			<!-- <ChalkyTrainerViewButtonToggleSound title="Toggle Sound" /> -->

			<ChalkyTrainerViewButtonMenu v-on:click.native="Handle_OnClickMenu" />
		</nav>
	</section>
</template>

<script lang="ts">
	import ChalkySticks from '@chalkysticks/sdk';
	import ViewBase from '@/Core/View.vue';
	import { Component } from 'vue-property-decorator';
	import { Event, Store } from '@chalkysticks/vue2-trainer';

	/**
	 * Async component definitions for lazy loading trainer buttons.
	 * Only loaded when the controls are actually rendered.
	 */
	const asyncComponents = {
		ChalkyTrainerViewButtonFullscreen: () =>
			import('@chalkysticks/vue2-trainer/src/components').then((m) => m.ViewButtonFullscreen),

		ChalkyTrainerViewButtonRackEight: () =>
			import('@chalkysticks/vue2-trainer/src/components').then((m) => m.ViewButtonRackEight),

		ChalkyTrainerViewButtonRackNine: () =>
			import('@chalkysticks/vue2-trainer/src/components').then((m) => m.ViewButtonRackNine),

		ChalkyTrainerViewButtonToggleMove: () =>
			import('@chalkysticks/vue2-trainer/src/components').then((m) => m.ViewButtonToggleMove),

		ChalkyTrainerViewButtonToggleSound: () =>
			import('@chalkysticks/vue2-trainer/src/components').then((m) => m.ViewButtonToggleSound),
	};

	/**
	 * Control panel for the Play trainer view. Provides navigation buttons
	 * for fullscreen, racking, move mode, and sound toggle. Uses async
	 * components from the trainer library to minimize initial load.
	 *
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package View/Play
	 * @project ChalkySticks App
	 */
	@Component({
		components: asyncComponents,
	})
	export default class ViewPlayControls extends ViewBase {
		/**
		 * @return Store
		 */
		protected get trainerStore() {
			return Store;
		}

		/**
		 * @return boolean
		 */
		protected get isAdmin(): boolean {
			return this.$store.getters['authentication/user']?.id == '1' || this.$store.getters.isSpecial;
		}

		/**
		 * @return boolean
		 */
		protected get isMoveMode(): boolean {
			return this.trainerStore.getters['game/inputMode'] === 'dragball';
		}

		/**
		 * @return boolean
		 */
		protected get isLoggedIn(): boolean {
			return !!this.$store.getters['authentication/user'];
		}

		// region: Event Handlers
		// ---------------------------------------------------------------------------

		/**
		 * @param PointerEvent e
		 * @return Promise<void>
		 */
		protected async Handle_OnClickMenu(e: PointerEvent): Promise<void> {
			e.preventDefault();

			this.$emit('showSettings');
		}

		/**
		 * @param PointerEvent e
		 * @return Promise<void>
		 */
		protected async Handle_OnClickToggleLines(e: PointerEvent): Promise<void> {
			e.preventDefault();

			this.$store.dispatch('trainer/toggleAimLines');
		}

		// endregion: Event Handlers
	}
</script>

<style lang="scss">
	.view-play-controls {
		// Styles inherited from parent overlay
	}

	// State
	// ---------------------------------------------------------------------------

	.view-play-controls button.togglable:not(.state-active) {
		opacity: 0.5;
	}

	.view-button-togglemove.active {
		button {
			background: var(--chalky-red) !important;
		}

		svg path {
			stroke: var(--chalky-white);
		}
	}
</style>
